import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE } from '../constants';
import { NAME } from './constants';

export const apiProvider = new BaseApi(DMS_MODULE, NAME);
